'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TenantSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectorModal = require('./SelectorModal');

var _SelectorModal2 = _interopRequireDefault(_SelectorModal);

var _fulfillerIdentity = require('../../services/fulfillerIdentity');

var _merchantConfig = require('../../services/merchantConfig');

var _customizr = require('../../services/customizr');

var _lodash = require('lodash.find');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable jsx-a11y/no-static-element-interactions */
var HeaderLink = function HeaderLink(_ref) {
  var selectedTenant = _ref.selectedTenant,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'span',
    null,
    selectedTenant && 'Acting as: ',
    _react2.default.createElement(
      'a',
      { className: 'clickable', onClick: onClick },
      selectedTenant || 'Select profile'
    )
  );
};
/* eslint-enable jsx-a11y/no-static-element-interactions */

HeaderLink.propTypes = {
  selectedTenant: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};

HeaderLink.defaultProps = {
  selectedTenant: undefined,
  onClick: undefined
};

var countTotalTenants = function countTotalTenants() {
  for (var _len = arguments.length, tenants = Array(_len), _key = 0; _key < _len; _key++) {
    tenants[_key] = arguments[_key];
  }

  return tenants.map(function (t) {
    return t.length;
  }).reduce(function (accum, numTenants) {
    return accum + numTenants;
  }, 0);
};
var hasOneTenant = function hasOneTenant() {
  return countTotalTenants.apply(undefined, arguments) === 1;
};

var TenantSelector = exports.TenantSelector = function (_Component) {
  _inherits(TenantSelector, _Component);

  function TenantSelector(props) {
    _classCallCheck(this, TenantSelector);

    var _this = _possibleConstructorReturn(this, (TenantSelector.__proto__ || Object.getPrototypeOf(TenantSelector)).call(this, props));

    _this.loadTenants = function () {
      _this.setState({ fetchingFulfillers: true, fetchingMerchants: true, fetchingSettings: true });
      var resourceType = _this.props.resourceType;
      // load data if it doesn't exist on the static members and it's necessary for the configuration

      Promise.all([!TenantSelector.allowedFulfillers && (!resourceType || resourceType === 'fulfiller') ? (0, _fulfillerIdentity.getFulfillers)(_this.props.authToken, _this.props.environment) : Promise.resolve(TenantSelector.allowedFulfillers), !TenantSelector.allowedMerchants && (!resourceType || resourceType === 'merchant') ? (0, _merchantConfig.getMerchants)(_this.props.authToken, _this.props.environment) : Promise.resolve(TenantSelector.allowedMerchants), !TenantSelector.savedTenants ? (0, _customizr.getSavedTenants)(_this.props.authToken, _this.props.environment) : Promise.resolve(TenantSelector.savedTenants)]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 3),
            fulfillers = _ref3[0],
            merchants = _ref3[1],
            savedTenants = _ref3[2];

        TenantSelector.allowedFulfillers = fulfillers && !TenantSelector.allowedFulfillers ? fulfillers.map(function (fulfiller) {
          return {
            label: fulfiller.name,
            value: fulfiller.id.toString(),
            altValue: fulfiller.fulfillerId
          };
        }) : TenantSelector.allowedFulfillers;
        TenantSelector.allowedMerchants = merchants && !TenantSelector.allowedMerchants ? merchants.map(function (merchant) {
          return { label: merchant.name, value: merchant.id };
        }) : TenantSelector.allowedMerchants;
        TenantSelector.savedTenants = savedTenants;
        var allowedMerchants = TenantSelector.allowedMerchants || [];
        var allowedFulfillers = TenantSelector.allowedFulfillers || [];
        var selectedTenant = _this.state.selectedTenant;

        // set selected tenant from settings.  start with the selectedTenant property and fall back to recentMerchant and recentFulfiller if available.

        if (savedTenants.selectedTenant && savedTenants.selectedTenant.tenantType === resourceType || !resourceType) {
          selectedTenant = savedTenants.selectedTenant;
        } else if (resourceType === 'merchant' && savedTenants.recentMerchant) {
          selectedTenant = savedTenants.recentMerchant;
        } else if (resourceType === 'fulfiller' && savedTenants.recentFulfiller) {
          selectedTenant = savedTenants.recentFulfiller;
        }
        var tenantDetails = selectedTenant ? {
          tenantId: selectedTenant.value,
          tenantName: selectedTenant.label,
          tenantType: selectedTenant.resourceType
        } : {};

        //if there is only one tenant, select it
        if (!selectedTenant && allowedMerchants.length + allowedFulfillers.length === 1) {
          selectedTenant = allowedMerchants.length ? _extends({}, allowedMerchants[0], { resourceType: 'merchant' }) : _extends({}, allowedFulfillers[0], { resourceType: 'fulfiller' });
        }

        //if there is a selected tenant notify the application
        if (selectedTenant) {
          _this.props.onCurrentTenantChange(selectedTenant);
        }

        //notify the application that the selector is ready
        _this.props.onReady();

        _this.setState(_extends({
          fetchingFulfillers: false,
          fetchingMerchants: false,
          fetchingSettings: false,
          allowedMerchants: allowedMerchants,
          allowedFulfillers: allowedFulfillers,
          selectedTenant: selectedTenant
        }, tenantDetails));
      }).catch(function (error) {
        return console.error(error);
      });
    };

    _this.onTenantTypeSelected = function (e, tenantType) {
      if (tenantType === _this.state.tenantType) {
        return;
      }
      _this.setState({ tenantType: tenantType, tenantId: undefined, tenantName: undefined });
    };

    _this.onTenantValueSelected = function (tenant) {
      var _ref4 = tenant || {},
          value = _ref4.value,
          label = _ref4.label,
          resourceType = _ref4.resourceType;

      var newState = { tenantId: value, tenantName: label };
      if (resourceType) {
        newState.tenantType = resourceType;
      }
      _this.setState(newState);
    };

    _this.showModal = function () {
      var _ref5 = _this.state.selectedTenant || {},
          value = _ref5.value,
          label = _ref5.label,
          resourceType = _ref5.resourceType;

      _this.setState({
        showModal: true,
        tenantId: value,
        tenantName: label,
        tenantType: resourceType || _this.props.resourceType
      });
    };

    _this.closeModal = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
      _this.setState({
        showModal: false
      });
    };

    _this.save = function () {
      var _this$state = _this.state,
          tenantId = _this$state.tenantId,
          tenantName = _this$state.tenantName,
          tenantType = _this$state.tenantType;

      var tenant = {
        value: tenantId,
        label: tenantName,
        resourceType: tenantType
      };
      _this.setState({ selectedTenant: tenant });
      var savedSetting = { selectedTenant: tenant };
      if (tenantType === 'merchant') {
        savedSetting.recentMerchant = tenant;
      }
      if (tenantType === 'fulfiller') {
        savedSetting.recentFulfiller = tenant;
        var fulfiller = (0, _lodash2.default)(_this.state.allowedFulfillers, function (tenant) {
          return tenant.value === tenantId;
        });
        tenant.altValue = fulfiller ? fulfiller.altValue : null;
      }
      TenantSelector.savedTenants = _extends({}, TenantSelector.savedTenants, savedSetting);
      (0, _customizr.putSavedTenants)(_this.props.authToken, _this.props.environment, TenantSelector.savedTenants);

      _this.props.onCurrentTenantChange(tenant);
      _this.closeModal();
    };

    _this.state = { selectedTenant: undefined, allowedMerchants: [], allowedFulfillers: [], showModal: false };
    return _this;
  }

  _createClass(TenantSelector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadTenants();
      if (this.props.resourceType) {
        this.setTenantTypeStateFromProps();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.resourceType !== prevProps.resourceType) {
        this.setTenantTypeStateFromProps();
      }
    }
  }, {
    key: 'setTenantTypeStateFromProps',
    value: function setTenantTypeStateFromProps() {
      this.setState({ tenantType: this.props.resourceType });
    }
  }, {
    key: 'render',
    value: function render() {
      var selectedTenant = this.state.selectedTenant;

      var _ref6 = selectedTenant || {},
          label = _ref6.label;

      var _props = this.props,
          resourceType = _props.resourceType,
          forceSelection = _props.forceSelection,
          showLink = _props.showLink,
          show = _props.show,
          modalTitle = _props.modalTitle,
          modalHelpText = _props.modalHelpText;
      var _state = this.state,
          showModal = _state.showModal,
          tenantType = _state.tenantType,
          tenantName = _state.tenantName,
          tenantId = _state.tenantId,
          allowedMerchants = _state.allowedMerchants,
          allowedFulfillers = _state.allowedFulfillers,
          fetchingFulfillers = _state.fetchingFulfillers,
          fetchingMerchants = _state.fetchingMerchants;

      var mustSelectTenant = !selectedTenant && forceSelection;

      // TODO: fix test environment so that document is not undefined
      // @cimpress/react-components/lib/Modal blows up on any reference to document.body
      if (allowedMerchants.length + allowedFulfillers.length > 0) {
        return _react2.default.createElement(
          'div',
          { style: showLink ? { marginTop: '13px' } : {} },
          showLink ? _react2.default.createElement(HeaderLink, { onClick: this.showModal, selectedTenant: label }) : null,
          _react2.default.createElement(_SelectorModal2.default, {
            show: showModal || show,
            selectedTenant: tenantId,
            mustSelectTenant: mustSelectTenant,
            onClose: this.closeModal,
            onSave: this.save,
            canSave: !!(tenantId && tenantName && tenantType),
            loading: fetchingFulfillers || fetchingMerchants,
            onSelectType: this.onTenantTypeSelected,
            onSelectTenant: this.onTenantValueSelected,
            merchants: !resourceType || resourceType === 'merchant' ? allowedMerchants : [],
            fulfillers: !resourceType || resourceType === 'fulfiller' ? allowedFulfillers : [],
            resourceType: resourceType || tenantType || '',
            title: modalTitle,
            helpText: modalHelpText
          })
        );
      }

      return null;
    }
  }]);

  return TenantSelector;
}(_react.Component);

TenantSelector.propTypes = {
  authToken: _propTypes2.default.string.isRequired,
  onCurrentTenantChange: _propTypes2.default.func.isRequired,
  resourceType: _propTypes2.default.string,
  forceSelection: _propTypes2.default.bool,
  show: _propTypes2.default.bool,
  environment: _propTypes2.default.string,
  showLink: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  modalTitle: _propTypes2.default.string,
  modalHelpText: _propTypes2.default.string,
  onReady: _propTypes2.default.func.isRequired
};
TenantSelector.defaultProps = {
  environment: 'prd',
  resourceType: null,
  forceSelection: false,
  showLink: false,
  show: false,
  onClose: null,
  modalTitle: 'Choose who to view',
  modalHelpText: '',
  onReady: function onReady() {}
};
exports.default = TenantSelector;
//# sourceMappingURL=TenantSelector.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/components/tenant/TenantSelector.js
// module id = 516
// module chunks = 0